import React, { memo } from 'react';
import { QuestionCard } from '../ProductStyles';

const FAQItem = memo(({ faq, onAnswerChange }) => {
  return (
    <QuestionCard>
      <input
        style={{
          width: '100%',
          padding: '0.5rem',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          border: '1px solid rgba(100, 182, 255, 0.3)',
          borderRadius: '4px',
          color: '#64B6FF',
          fontSize: '1rem',
          fontWeight: 'bold',
          marginBottom: '0.5rem'
        }}
        placeholder="Digite sua pergunta frequente..."
        defaultValue={faq.question || ''}
        onBlur={(e) => onAnswerChange(faq.id, faq.answer, e.target.value)}
      />
      <textarea
        style={{
          width: '100%',
          minHeight: '80px',
          padding: '0.5rem',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          border: '1px solid rgba(100, 182, 255, 0.3)',
          borderRadius: '4px',
          color: 'rgba(255, 255, 255, 0.8)',
          fontSize: '0.9rem',
          resize: 'vertical'
        }}
        placeholder="Adicione sua resposta aqui..."
        defaultValue={faq.answer || ''}
        onBlur={(e) => onAnswerChange(faq.id, e.target.value, faq.question)}
      />
    </QuestionCard>
  );
});

export default FAQItem;
